<template>
  <div class="betslip-container"
       v-bind:class="{'bets-container-overlay':isPlacingBets}">

    <div class="empty-betslip" v-if="backBets.length === 0 && layBets.length  === 0">
      <div class="empty-betslip-image">
        <v-icon>krypt-betslip</v-icon>
      </div>
      <div class="empty-betslip-text">
        <span>{{$t('bets.noPendingBets')}}</span>
      </div>
    </div>
    <div class="bet-content" v-if="!(backBets.length === 0)|| !(layBets.length  === 0)"
         ref="betContentRef">
      <v-expansion-panels
        class="bets"
        :multiple="true"
        v-model="activePanels">

        <v-expansion-panel class="bets-back" ref="backBetsPanel" v-show="backBets.length >0"
        >

          <v-expansion-panel-header
            expand-icon="krypt-arrow-down"
            class="bets-back-header bets-header"
          >
            <span>{{ $t('bets.backHeader')}}</span>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <BetCard v-for="(backBet,betPosition) in backBets" v-bind:key="backBet.refId"
                     :betData="backBet"
                     :betPosition="betPosition"
                     :betSlipFirstTime="firstTime"
                     :type="'back'"></BetCard>
          </v-expansion-panel-content>

        </v-expansion-panel>
        <v-expansion-panel class="bets-lay" ref="layBetsPanel" v-show="layBets.length >0"

        >

          <v-expansion-panel-header
            expand-icon="krypt-arrow-down"
            class="bets-header bets-lay-header"
          >
            <span>{{ $t('bets.layHeader')}}</span>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <BetCard v-for="(layBet,betPosition) in layBets" v-bind:key="layBet.refId"
                     :betPosition="betPosition"
                     :betSlipFirstTime="firstTime"
                     :betData="layBet" :type="'lay'"></BetCard>
          </v-expansion-panel-content>

        </v-expansion-panel>

      </v-expansion-panels>
    </div>

    <div class="place-bet-container">
      <div class="place-bet-amount-wrapper">
        <div class="keep-in-play">
          <input v-bind:class="{'keep-in-play-checkbox--disabled':isPlacingBets }"
                 v-bind:disabled="isPlacingBets" class="keep-in-play-checkbox" type="checkbox"
                 v-model="keepBetOnLive">
          <div class="visible-keep-in-play-checkbox">
            <v-icon>krypt-success</v-icon>
          </div>
          <span>{{ $t('bets.keepInPlay')}}</span>
        </div>
        <div class="place-bet-amount"
             v-bind:class="{'liability-calculating':isCalculatingLiability }">
          <span class="place-bet-amount-desc">{{ $t('bets.totalLiability') | removeDiacriticsFromUppercase }}</span>
          <v-icon v-show="isCalculatingLiability">krypt-loader</v-icon>
          <span class="bet-amount" v-show="!isCalculatingLiability">{{`${this.userCurrency}` }}{{calculatedLiability | numberWithCommas}}</span>
        </div>
      </div>
      <div class="place-bet-amount-controls">
        <div class="cancel-bets" @click="clearAllBets"
             v-bind:class="{'cancel-bets--disabled':isPlacingBets  }">
          <span>{{ $t('bets.cancelAll') |
              removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="place-bet-button-wrapper">
          <div @click="placeBets" class="place-bet-button"
               v-bind:class="{'place-bet-button-spinning':isPlacingBets,'awaiting-liability-calculation':isCalculatingLiability }">
            <v-icon v-show="isPlacingBets">krypt-loader</v-icon>
            <span v-bind:class="{'place-bet-button-text':isPlacingBets }">{{ $t('bets.placeBets') |
              removeDiacriticsFromUppercase}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BetCard from '@/components/other/betCard';
import { debounce } from "debounce";
// @ts-ignore
// window.debounce = debounce;
export default {
  data: function () {
    return {
      keepBetOnLive: false,
      firstTime: true,
      activePanels: [0, 1]
    };
  },
  mounted: function () {
    if((!this.userIsTrader) && (this.isLoggedIn) && this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }).length > 0 ){
      this.$store.commit('setIsCalculatingLiability',true)
      this.$store.dispatch('calculateLiability',this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }))
    } else {
          this.$store.commit('setCalculatedLiability', 0);
          this.$store.commit('setIsCalculatingLiability', false);
    };
  },
  methods: {
    clearAllBets: function () {
      if (!this.isPlacingBets) {
        this.$store.commit('clearAllBetsInBetslip');
      }
    },
    placeBets: function () {
      if (!this.isPlacingBets && !this.isCalculatingLiability ) {
        let allBets = this.layBets.concat(this.backBets);
        let backBets = JSON.parse(JSON.stringify(this.backBets))
          .map((bet) => {
            bet.isValid = true;
            return bet;
          });
        let layBets = JSON.parse(JSON.stringify(this.layBets))
          .map((bet) => {
            bet.isValid = true;
            return bet;
          });
        let backBetsFiltered = [];
        let layBetsFiltered = [];
        let canBet = true;

        if(this.isInLockdown){
          this.$store.commit('setBetslipMessage', {
            type: 'error',
            message: this.$t('bets.errorMessages.isInLockdown'),
            messagePersistence: 'temporaryOnClickRemove'
          });
          canBet = false;
        }
        if (this.calculatedLiability === null || this.calculatedLiability === '-' || this.calculatedLiability > this.userBalance) {
          this.$store.commit('setBetslipMessage', {
            type: 'error',
            message: this.$t('bets.errorMessages.notEnoughBalance') + ` (${this.userCurrency}${this.$options.filters.numberWithCommas(this.userBalance)}).`,
            messagePersistence: 'temporaryOnClickRemove'
          });
          canBet = false;
        }
        if(!this.isLoggedIn) {
          this.$store.commit('setBetslipMessage', {
            type: 'error',
            messagePersistence: 'temporaryOnClickRemove',
            message:
              this.$t('bets.errorMessages.notLoggedIn')
          });
          canBet = false;

        }

        for (let y in backBets) {
          if (backBets[y].stake === 0 || backBets[y].stake === '') {
            this.$store.commit('addBetMessage', {
              id: backBets[y].refId,
              messageType: 'temporaryRemoveOnStakeClick',
              messageId: 'noStake',
              message:
                this.$t('bets.errorMessages.noStake')
            });

            backBets[y].isValid = false;
            continue;

          }
          if (backBets[y].stake < this.minimumLiability) {
            this.$store.commit('addBetMessage', {
              id: backBets[y].refId,
              messageType: 'temporaryRemoveOnStakeClick',
              messageId: 'liabilityTooLow',
              message: this.$t('bets.errorMessages.liabilityTooLow') + ` (${this.userCurrency}${this.$options.filters.numberWithCommas(this.minimumLiability)}).`
            });

            backBets[y].isValid = false;
            continue;
          }
          for (let j in layBets) {
            if (layBets[j].runnerId === backBets[y].runnerId && layBets[j].odds >= backBets[y].odds) {
              this.$store.commit('addBetMessage', {
                id: layBets[j].refId,
                messageType: 'temporaryOnClickRemove',
                message:
                  this.$t('bets.errorMessages.layGreaterThanBack')
              });
              this.$store.commit('addBetMessage', {
                id: backBets[y].refId,
                messageType: 'temporaryOnClickRemove',
                message:
                  this.$t('bets.errorMessages.backLessThanLay')
              });

              backBets[y].isValid = false;
              layBets[y].isValid = false;

            }
          }
        }
        for (let b in layBets) {
          if (layBets[b].stake === 0 || layBets[b].stake === '') {
            this.$store.commit('addBetMessage', {
              id: layBets[b].refId,
              messageType: 'temporaryRemoveOnStakeClick',
              messageId: 'noStake',
              message:
                this.$t('bets.errorMessages.noStake')
            });

            layBets[b].isValid = false;

          } else if ((this.calculateLiability(layBets[b]) < this.minimumLiability)) {
            this.$store.commit('addBetMessage', {
              id: layBets[b].refId,
              messageType: 'temporaryRemoveOnStakeClick',
              messageId: 'liabilityTooLow',
              message:
                this.$t('bets.errorMessages.liabilityTooLow') + ` (${this.userCurrency}${this.$options.filters.numberWithCommas(this.minimumLiability)}).`
            });

            layBets[b].isValid = false;
          }
        }
        backBetsFiltered = backBets.filter((bet) => {
          return bet.isValid === true;
        });
        layBetsFiltered = layBets.filter((bet) => {
          return bet.isValid === true;
        });
        this.$store.commit('applyValidationFlagsForBets', {
          back: backBets,
          lay: layBets
        });
        if ((backBetsFiltered.length !== 0 || layBetsFiltered.length !== 0) && canBet) {

          if (this.keepBetOnLive) {
            for (let iE in backBetsFiltered) {
              backBetsFiltered[iE].keepBetOnLive = true;
            }
            for (let iS in layBetsFiltered) {
              layBetsFiltered[iS].keepBetOnLive = true;
            }
          }
          this.$nextTick(() => {
            console.log(layBetsFiltered.concat(backBetsFiltered)[0]);
            this.$store.dispatch('placeBets', layBetsFiltered.concat(backBetsFiltered));
          });
        }

      }

    },
    validateAllBets: function (bets) {
      let hasEnoughBalanceForBets = true;
      for (let i in bets) {
        if (bets[i].stake === 0 || bets[i].stake === '') {

        } else if (bets[i].stake < this.minimumLiability) {

        } else if (this.currentTotalLiability > this.userBalance) {

        }
      }
    },
    validateBet: function (bet) {

    },
    scrollToShowNewestBet: function (bet) {
      this.betSlipFirstTime = true;
      if (bet.betType === 'back') {
        this.$nextTick(() => {
          /* this.$refs.backBetsPanel.$el.scrollIntoView();
          this.$refs.betslipContainerRef.scrollBy(0, -8); */
          this.$refs.betContentRef.scrollTop = this.$refs.backBetsPanel.$el.offsetTop - 8;
        });

      } else if (bet.betType === 'lay') {
        this.$nextTick(() => {
          /* this.$refs.layBetsPanel.$el.scrollIntoView();
          this.$refs.betslipContainerRef.scrollBy(0, -8); */
          this.$refs.betContentRef.scrollTop = this.$refs.layBetsPanel.$el.offsetTop - 8;
        });

      }
      ;
    },
    calculateLiability: function (bet) {
      return (bet.stake * (Number(bet.odds) - 1)) !== 0 ? (bet.stake * (Number(bet.odds) - 1)).toFixed(2) : '0';

    }
  },
  watch: {
    newestBet: function (newValue, oldValue) {
      if (newValue !== '') {
        setTimeout(() => {
          this.scrollToShowNewestBet(newValue);
          setTimeout(() => {
            this.scrollToShowNewestBet(newValue);
          }, 300);
        }, 300);
      }
    },
    layBets: {
      deep: true,
      handler: debounce(function () {
        let totalBets = this.layBets.concat(this.backBets);
        if (totalBets.length >0 && (this.isLoggedIn) && this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }).length > 0) {
          this.$store.commit('setIsCalculatingLiability', true);
          this.$store.dispatch('calculateLiability', this.layBets.concat(this.backBets).filter(function (bet) {
            return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
          }));
        }else{
          this.$store.commit('setCalculatedLiability', 0)
          this.$store.commit('setIsCalculatingLiability', false)
        };
      }, 500)
    },
    backBets: {
      deep: true,
      handler: debounce(function () {
        let totalBets = this.layBets.concat(this.backBets);
        if (totalBets.length >0 && (this.isLoggedIn) && this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }).length > 0) {
          this.$store.commit('setIsCalculatingLiability', true);
          this.$store.dispatch('calculateLiability', this.layBets.concat(this.backBets).filter(function (bet) {
            return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
          }));
        }else{
          this.$store.commit('setCalculatedLiability', 0)
          this.$store.commit('setIsCalculatingLiability', false)
        };
      }, 500)
    },
    openBetsBatchCounter:function () {
      if((!this.userIsTrader) && this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }).length > 0 ){
        this.$store.commit('setIsCalculatingLiability',true)
        this.$store.dispatch('calculateLiability',this.layBets.concat(this.backBets).filter(function (bet) {
          return !(bet.stake === '' || bet.odds === '' || bet.odds === null || bet.stake === null || bet.odds < 1.01 || bet.stake < 0.01);
        }))
      };
    }

  },
  computed: {
    isInLockdown:function (){
      return this.$store.state.isInLockdown;
    },
    openBetsBatchCounter: function () {
      return this.$store.state.bets.active.batchCounter;
    },
    calculatedLiability: function () {
      return Math.abs(this.$store.state.bets.betslip.calculatedLiability);
    },
    isCalculatingLiability: function () {
      return this.$store.state.bets.betslip.isCalculatingLiability;
      // return true;
    },
    shouldRecalculateLiability: function () {
      // let shouldRecalculateToggler = false;
      // let totalLiability = this.layBets.concat(this.backBets)
      //   .reduce(
      //     (total, obj) => {
      //       // total = Number(total)
      //       if (obj.betType === 'back') {
      //         total += Number(obj['stake']);
      //
      //       } else {
      //         total += (Number(obj['stake']) * (Number(obj['odds']) - 1));
      //
      //       }
      //       return total;
      //     }, 0);
    },
    isLoggedIn: function () {
      return this.$store.state.user.isLoggedIn;
    },
    isPlacingBets: function () {
      return this.$store.state.bets.betslip.isPlacingBets;
    },
    userBalance: function () {
      return this.$store.state.user.info.balance;
    },
    minimumLiability: function () {
      return this.$store.state.user.minimumLiability;
    },
    newestBet: function () {
      return this.$store.state.bets.betslip.newestBet;
    },
    layBets: function () {
      return this.$store.state.bets.betslip.layBets;
    },
    backBets: function () {
      return this.$store.state.bets.betslip.backBets;
    },
    betsList: function () {
      return this.$store.state.bets.betslip.betList;
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    userIsTrader: function () {
      return this.$store.state.user.isTrader;
    },
    currentTotalLiability: function () {
      let totalLiability = this.layBets.concat(this.backBets)
        .reduce(
          (total, obj) => {
            // total = Number(total)
            if (obj.betType === 'back') {
              total += Number(obj['stake']);

            } else {
              total += (Number(obj['stake']) * (Number(obj['odds']) - 1));

            }
            return total;
          }, 0);
      return totalLiability.toFixed(2);
    }
  },
  components: {
    BetCard,
  },
  name: 'BetSlip'
};
</script>

<style scoped>
  .bets {
    padding: 8px;
  }

  .betslip-container {
    width: 100%;
    overflow: auto;
    overscroll-behavior: contain;
  }


  .bets-back {
    margin-bottom: 8px;
  }

  >>> .bets.v-expansion-panels > .bets-back,
  >>> .bets.v-expansion-panels > .bets-lay {
    border-radius: 6px;
  }

  .bets-header {
    padding: 8px !important;
    min-height: 0px;
  }

  .bets-header span {
    margin-right: 8px;
  }

  .bets-back-header {
    background-color: var(--superman);
  }

  .bets-lay-header {
    background-color: var(--lex-luthor);
  }

  .bets-header span {
    font-size: 12px;
    line-height: 16px;
    display: flex;
    font-weight: bold;
    color: white;
  }

  /*Vuetify*/

  .v-expansion-panel--active:not(:first-child), .v-expansion-panel--active + .v-expansion-panel {
    margin-top: 0px !important;
  }

  >>> .v-expansion-panel-header__icon > i {
    color: white !important;
  }

  >>> .v-expansion-panel::before {
    box-shadow: none !important;
  }

  >>> .v-expansion-panel--active {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
  }

  >>> .v-expansion-panel > .bets-header {
    border-radius: 6px;
  }

  >>> .v-expansion-panel {
    transition: border-radius 1s ease-in-out;
    border-radius: 6px;
  }

  >>> .v-expansion-panel--active > .bets-header {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  >>> .v-expansion-panel-content__wrap {
    padding: 0px;
  }

  >>> .v-expansion-panel:not(:first-child)::after {
    border-top: none;
  }

  >>> .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
    opacity: 0 !important;
  }

  .place-bet-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    width: 360px;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1) !important;
    z-index: 2;
    background: white;
    min-height: 100px;
  }

  .place-bet-amount-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid var(--grey-200);
  }

  .place-bet-amount-controls {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 8px;
    overflow: hidden;
  }

  .cancel-bets {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    height: max-content;
    overflow: hidden;
  }

  .cancel-bets > span {
    line-height: 16px;
    font-size: 12px;
    font-weight: bold;
    color: var(--grey-400);
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .cancel-bets:hover > span {
    color: var(--grey-500);
  }

  .cancel-bets--disabled {
    cursor: not-allowed;
  }

  .cancel-bets.cancel-bets--disabled:hover > span {
    color: var(--grey-400);
  }

  .place-bet-button-wrapper {
    max-width: 100%;
  }

  .place-bet-button {
    display: flex;
    flex-direction: row;
    padding: 8px 16px;
    background-color: var(--primary);
    border-radius: 6px;
    cursor: pointer;
    margin-left: 8px;
  }

  .place-bet-button > .v-icon {
    font-size: 14px;
    line-height: 16px;
    animation: spin 1s infinite linear;
  }

  .place-bet-button:not(.place-bet-button-spinning):not(.awaiting-liability-calculation):hover {
    background-color: var(--primary-state);
  }

  .place-bet-button.place-bet-button-spinning {
    cursor: default;
  }

  .place-bet-button.awaiting-liability-calculation {
    cursor: default;
  }

  .liability-calculating > .v-icon {
    font-size: 14px;
    line-height: 19px;
    -webkit-animation: spin-data-v-145cb6d0 1s infinite linear;
    animation: spin-data-v-145cb6d0 1s infinite linear;
  }

  .liability-calculating > .v-icon:before {
    color: var(--grey-400)
  }

  .place-bet-button > span {
    display: flex;
    align-items: center;
    color: white;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    white-space: nowrap;
  }

  .place-bet-button-text {
    padding-left: 8px;
  }

  .keep-in-play {
    display: flex;
    position: relative;
    align-items: center;
  }

  .keep-in-play-checkbox {
    margin-right: 8px;
    opacity: 0;
    height: 16px;
    width: 16px;
  }

  .place-bet-amount {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 16px;
  }

  .place-bet-amount-desc {
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: right;
    color: var(--grey-400);
    margin-bottom: 2px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .bet-amount {
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-900);
  }

  .keep-in-play > span {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: var(--grey-900);
  }

  .empty-betslip {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 100px);
  }

  .empty-betslip-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
  }

  .empty-betslip-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
    font-size: 122px;
    color: var(--grey-300);
  }

  .empty-betslip-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-betslip-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
  }

  .visible-keep-in-play-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    position: absolute;
    background-color: var(--grey-200);
    border: 1px solid var(--grey-300);
    box-sizing: border-box;
    border-radius: 2px;
    pointer-events: none;
    transition: border 0.2s ease-in-out;
  }

  .keep-in-play-checkbox {
    cursor: pointer;
  }

  .keep-in-play-checkbox--disabled {
    cursor: not-allowed;
  }

  .keep-in-play-checkbox:not(.keep-in-play-checkbox--disabled):hover ~ .visible-keep-in-play-checkbox {
    border-color: var(--grey-400);
  }

  .keep-in-play-checkbox:checked ~ .visible-keep-in-play-checkbox {
    background-color: var(--primary);
    border-color: var(--primary-state);
  }

  .keep-in-play-checkbox:not(.keep-in-play-checkbox--disabled):checked:hover ~ .visible-keep-in-play-checkbox {
    border-color: var(--superman-state);
  }

  .visible-keep-in-play-checkbox > .v-icon {
    color: white;
    font-size: 14px;
    position: relative;
    display: none;
    pointer-events: none;
  }

  .keep-in-play-checkbox:checked ~ .visible-keep-in-play-checkbox > .v-icon {
    display: flex;

  }

  .bets-container-overlay:after {
    display: flex;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 1;
    opacity: 0.6;
    top: 0;
  }

  .bets-container-loader {
    position: absolute;
  }

  .bets-container-loader--active {
    width: 100%;
    height: 100%;
  }

  .bets-container-loader--active > .v-icon {
    font-size: 32px;
    z-index: 6;
    top: 50%;
    right: -50%;
    animation: spin 1s infinite linear;
  }

  .bet-content {
    max-height: calc(100% - 100px);
    overflow: auto;
  }

  /*Animations*/

  @keyframes spin {
    0% {
      transform: rotateZ(0)
    }
    100% {
      transform: rotateZ(360deg)
    }
  }

  /*Media Queries*/

  @media screen and (max-width: 1279px) {
    .place-bet-container {
      position: absolute !important;
      width: 100%;
    }
  }

  @media screen and (max-height: 386px) {
    .place-bet-container {
      position: relative !important;
      width: 100%;
    }

    .betslip-container {
      max-height: 100%;
      display: flex;
      flex-direction: column;
    }

    .bet-content {
      margin-bottom: auto;
      max-height: unset;
      overflow: unset;
    }

    .empty-betslip {
      height: unset;
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  @media screen and (max-height: 767px) and (min-width: 1280px) {
    .place-bet-container {
      position: absolute !important;
      width: 100%;
    }

  }

</style>
